// extracted by mini-css-extract-plugin
module.exports = {"container_product_card":"CategoriesProduct_container_product_card__32hc-","product_card":"CategoriesProduct_product_card__2JYUL"};